// Two-layer ink-wash mountain silhouette. The back layer drifts slowly with
// .anim-mist-drift so the scene reads as morning fog over peaks. Used behind
// portraits on swipe cards, in library CTAs, at the bottom of flashcards,
// and pinned to the bottom of the page background.

interface InkMountainsProps {
  /** Height in px. Width fills container. Default 64. */
  height?: number;
  /** Disable the drift animation. */
  staticOnly?: boolean;
  /** Extra classes (typically positioning). */
  className?: string;
  /** Override the ink tint. Defaults to a warm grey-brown. */
  tint?: string;
}

export function InkMountains({
  height = 64,
  staticOnly = false,
  className = '',
  tint = '#3A2C24',
}: InkMountainsProps) {
  return (
    <div
      aria-hidden
      className={`pointer-events-none overflow-hidden ${className}`}
      style={{ height }}
    >
      {/* Back layer — softer, drifts. */}
      <svg
        viewBox="0 0 400 64"
        preserveAspectRatio="none"
        className={staticOnly ? '' : 'anim-mist-drift'}
        style={{ position: 'absolute', inset: 0, width: '106%', height: '100%' }}
      >
        <path
          d="M0 48 Q60 18 130 36 T260 28 T400 40 L400 64 L0 64 Z"
          fill={tint}
          opacity="0.07"
        />
      </svg>
      {/* Front layer — crisper, static. */}
      <svg
        viewBox="0 0 400 64"
        preserveAspectRatio="none"
        style={{ position: 'absolute', inset: 0, width: '100%', height: '100%' }}
      >
        <path
          d="M0 56 Q90 36 180 48 T400 50 L400 64 L0 64 Z"
          fill={tint}
          opacity="0.10"
        />
      </svg>
    </div>
  );
}
